<template>
  <div>
    <BaseButton primary @click="setShow(true)"> New pipeline </BaseButton>
    <NewPipelineForm v-if="show" @close="setShow(false)" @created="goToPipeline" />
  </div>
</template>

<script>
import NewPipelineForm from './NewPipelineForm.vue';

function data() {
  return {
    show: false,
  };
}

const methods = {
  setShow(value) {
    this.show = Boolean(value);
  },
  goToPipeline(pipelineId) {
    this.$router.push({
      name: 'admin.pipelines.pipelineId',
      params: {
        pipelineId,
      },
    });
  },
};

export default {
  components: { NewPipelineForm },
  data,
  methods,
};
</script>
